import { render, staticRenderFns } from "./Evidence.vue?vue&type=template&id=b4e05e36&scoped=true"
import script from "./Evidence.vue?vue&type=script&lang=js"
export * from "./Evidence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e05e36",
  null
  
)

export default component.exports